import { z } from "zod";
import { defineWidget } from "@/lib/home/widget";

/** A scratchpad in plain text (markdown welcome), saved as you type. */
export default defineWidget({
  type: "kourai.notes",
  version: 1,
  title: "Notes",
  description: "A scratchpad, saved as you type",
  sizes: ["s", "m", "l", "w", "xl"],
  defaultSize: "m",
  surfaces: ["newtab", "sidepanel"],
  data: "member",
  permissions: [],
  config: z.object({}),
  load: () => import("./notes-widget"),
});
